<template>
    <div class="flex flex-wrap">
        <div class="mr-2" v-for="(img_item,idx) in itemList" :key="idx" @click="currentIndex = idx">
            <div class="image-item">
                <img v-if="idx<=2" :src="img_item.img_url" alt="">
                <div class="wrap-image" v-if="idx == 2">
                    <i><span>{{itemList.length >= 3 ? `+${itemList.length-idx}` : ''}}</span></i>
                </div>
            </div>
        </div>
        <imagePreview :index="currentIndex" :images="itemList" @close="currentIndex = null"/>
    </div>
</template>

<script setup>
import { computed, ref } from "vue"
import imagePreview from "@/components/image-preview/index.vue"

const props = defineProps({
    itemList: {
        type: Array,
        default: ()=>[]
    }
})
const currentIndex = ref(null)
</script>

<style lang="scss">
.image-item{
    position: relative;
    cursor: pointer;
    img{
        height: 3rem;
        width: 3rem;
        border-radius: 5px;
        cursor: pointer;
        object-fit: cover;
    }
}
.wrap-image{
    position: absolute;
    top: 0;
    color: #FFF;
    height: 100%;
    width: 100%;
    opacity: 0.8;
    background: rgb(59 58 58 / 66%);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
        font-size: 16px;
        font-family: 'Kanit', 'sans-serif';
        padding-left: 2px;
    }
}
.image-plus-icon{
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;
    font-size: 12px;
}
</style>